import type { TableProps } from './interface';

export const withLogic =
  (Component: React.ComponentType<TableProps>): React.FC<TableProps> =>
  (props: TableProps) => {
    const isZebra = props.rowStyle === 'zebra' || props.zebra;
    const rows = props.headers.map((header) => ({
      cells: [
        {
          text: header.value,
          type: 'header',
          background: props.headerBackground || props.background
        },
        ...props.rows.map((row, i) => ({
          text: row[header.name] || `\u00A0`,
          background: isZebra && i % 2 === 0
        }))
      ]
    }));
    return (
      <Component
        {...{
          ...props,
          rows,
          background: Boolean(props.headerBackground),
          _hasFooter: Boolean(props.footer)
        }}
      />
    );
  };

export { TableProps };
